export const localePrefixRegex = /\/[a-zA-Z_-]{2,}/i;
export const localePrefix = '/:locale([a-zA-Z_-]{2,})';
